<template>
    <div id="API-component" style="width: 50%;">
        <template v-if="!step">
            <span class="dashboard-subtitle mb-5">Generate API key</span>

            <p class="dashboard-text">
                API keys are used to control your fylm.ai data from an external application.
                <br>
                Generate an API key below to get started.
            </p>

            <p class="dashboard-text text mb-10">
                <span class="color-red">IMPORTANT: </span>
                Once created, API key will be shown to you ONCE. Make sure you copy or download the API key so that you can
                use it in the external application.
            </p>

            <v-btn class="color-gray rounded-xl" outlined large @click="step = 1">Generate API Key</v-btn>
        </template>

        <template v-if="step == 1">
            <span class="dashboard-subtitle mb-5">Generate API key - Step 1</span>
            <p class="dashboard-text">Please name your key so that you can later identify it</p>

            <v-text-field
                v-model="form.name"
                :error-messages="form.$errors.name"
                class="color-gray mb-7"
                dark
                label="Name your API key"
                @blur="form.validate('name')"
                @input="delete form.$errors.name"
            />

            <v-btn class="color-gray account-button rounded-xl account-button" outlined large @click="generateAPIKey">
                Next
            </v-btn>
        </template>

        <template v-if="step == 2">
            <span class="dashboard-subtitle mb-5">Generate API key - Step 2</span>
            <p class="dashboard-text mb-10 color-warning">Please download a copy of your API key and safely store it.</p>

            <p class="dashboard-text mb-1">Your API key:</p>
            <span class="new-api-key">{{ newApiKey }}</span>

            <div class="button-container mt-5">
                <v-btn class="account-button color-gray rounded-xl mr-5" outlined large @click="downloadApiKey">
                    Download
                </v-btn>
                <v-btn class="account-button color-gray rounded-xl" outlined large @click="copyApiKey">
                    Copy
                </v-btn>
            </div>

            <v-btn class="color-green account-button rounded-xl mt-10" outlined large
                   @click="finishSetup"
            >Done
            </v-btn>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import * as rules from "vuelidate/lib/validators";

export default {
    data() {
        return {
            apiKeys: [],
            step: null,
            newApiKey: '',
            form: new Form(this, "form", {
                name: null,
            }),
        }
    },

    validations: {
        form: {
            name: {
                required: rules.required,
            },
        },
    },

    created() {
        this.getAPIKeys();
    },

    computed: {
        ...mapState('User', ['account']),
    },

    methods: {
        async generateAPIKey() {
            if (!this.form.validate()) {
                return;
            }

            let response = await this.$apiService.post(`accounts/${this.account.id}/api-key-generate`, this.form).catch(err => err.response);

            if (response.data.errors?.name) {
                this.$snackbar('API key name already taken.', 'error');
                this.form.name = null;
                return;
            }

            this.step = 2;

            this.newApiKey = response.data.api_key;
            this.$snackbar('API key generated successfully', 'success');
            await this.getAPIKeys();
        },

        async getAPIKeys() {
            let response = await this.$apiService.get(`accounts/${this.account.id}/api-keys`);
            this.apiKeys = response.data;
        },

        copyApiKey() {
            navigator.clipboard.writeText(this.newApiKey);
        },

        downloadApiKey() {
            let text = "fylm.ai API key\n\n";
            text += `Name: ${this.form.name}\n`;
            text += `Created at: ${new Date().toLocaleDateString("de")}\n`;
            text += `Key: ${this.newApiKey}`;
            let element = document.createElement("a");
            element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
            element.setAttribute("download", 'fylm - API key');
            element.style.display = "none";
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },

        finishSetup() {
            this.step = null;
            this.form.name = null;
        }
    },
}

</script>

<style lang="scss" scoped>
.api-keys-container {
    display: flex;
    flex-direction: column;

    .api-keys-header-container,
    .api-key-container {
        display: grid;
        grid-template-columns: 150px 200px 150px;
        align-items: center;
    }

    .api-key-container {
        height: 65px;
    }
}

.new-api-key {
    background: #31313f;
    padding: 15px 30px;
    display: inline-block;
    border-radius: 5px;
}
</style>